// quoteVersionApi.ts

import { QuoteVersionData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';

export const quotesVersionApi = apiResource<QuoteVersionData>('quote-versions');
